module.exports = __webpack_public_path__ + "images/logo.a0876aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/logo.png
// module id = Phjq
// module chunks = 19